import React  from 'react' 

const Divider = function Divider(props) {
    return (
        <div style={props.style || {}} className='divider'></div>
    )
}
export { Divider };
